import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('facs-card')
export class Card extends LitElement {
    render() {
        return html`
            <div class="card">
                <div class="title">
                    <slot name="title"></slot>
                </div>
                <slot>Missing content</slot>
            </div>
        `
    };

    static styles = css`
        .card {
            background: #fff;
            border-left: 0.25rem solid #E91F00;
            padding: 1rem 2rem;
            font-size: 1.125rem;

            @media (max-width: 840px) {
                padding: 1rem;
            }
        }

        .title {
            color: #0f2144;
            font-size: 1.375rem;
            font-weight: 600;
            margin: 0;
            display: flex;
            align-items: center;
        }

        ::slotted(p) {
            margin: 0;
        }
    `;
}